import { CompanySizeNumberAndLabels } from 'signup-constants/signupData/CompanySizeNumberAndLabels';
export const getCompanySizeFormatted = companySizeAnswer => {
  const companySize = CompanySizeNumberAndLabels[companySizeAnswer];
  return companySize || {
    companySizeNumber: null,
    companySizeLabel: null
  };
};